import * as React from "react"
import { Link } from "gatsby"
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews"
import { PrismicProvider } from "@prismicio/react"

import { repositoryConfigs } from "./src/utils/prismicPreviews"
import { linkResolver } from "./src/utils/linkResolver"

// import "bootstrap/dist/js/bootstrap.min.js"
import "bootstrap/dist/css/bootstrap.min.css"
import "./src/styles/global.css"

import { fireMetaEvent } from "./src/utils/useMeta"

// Track page views on every client-side route change
// Fires both the browser Pixel (if consent given) and the server-side CAPI
export const onRouteUpdate = () => {
  fireMetaEvent("PageView")
}



export const wrapRootElement = ({ element }) => {
  // console.log("-----Start---gatsby-browser.js-----")
  // console.log("linkResolver: ", linkResolver("test"))
  // console.log("-----End---gatsby-browser.js-----")

  return (
    <PrismicProvider
      linkResolver={linkResolver}
      internalLinkComponent={({ href, ...props }) => (
        <Link to={href} {...props} />
      )}
    >
      <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>
        {element}
      </PrismicPreviewProvider>

    </PrismicProvider>
  )
}
